/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IReviewConfigurationScope extends angular.IScope {
        model: models.ReviewConfigurationModel
    }

    export class ReviewConfigurationController implements IController {
        constructor(
            private scope: IReviewConfigurationScope,
            reviewConfigurationService:services.ReviewConfigurationService,
            $routeParams: angular.route.IRouteParamsService,
            formService: services.FormService,
            claimService: services.ClaimDefinitionService,
            emailConfigurationService: services.EmailConfigurationService,
            securityMatrixService: services.SecurityMatrixService,
            deleteService: services.DeleteService,
            systemLevelService: services.SystemLevelService,
            manageSystemCodesService: services.ManageSystemCodesService)
        {

            var processConfigId = $routeParams["id"];

            this.scope.model = new models.ReviewConfigurationModel(
                reviewConfigurationService,
                formService,
                claimService,
                emailConfigurationService,
                securityMatrixService,
                deleteService,
                systemLevelService,
                manageSystemCodesService,
                processConfigId);
        }
    }
}

warsApp.registerController("ReviewConfigurationController",
    [
        "$scope", "reviewConfigurationService", "$routeParams", "formService", "claimDefinitionService", "emailConfigurationService",
        "securityMatrixService", "deleteService", "systemLevelService", "manageSystemCodesService"
    ]);